import type { notifyObservationCommentProps } from "./observation-action-commented.type";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { CommentLink } from "@/modules/comment/comment-link";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";
import { UserAvatar } from "@/ui/user-avatar";

export const notifyObservationComment = ({
  notify,
  payload,
}: notifyObservationCommentProps) => {
  notify.info({
    key: payload.id,
    title: payload.comment.author_name,
    description: payload.comment.content,
    descriptionRows: 3,
    icon: (
      <UserAvatar
        size="small"
        statusColor="info"
        user={{ name: payload.comment.author_name }}
        withTooltip
      />
    ),
    actions: (
      <>
        <CommentLink
          customContext={payload.context}
          intervention={payload.intervention}
          observation={payload.observation}
          onClick={() => notify.close(payload.id)}
        />
        <OrganizationContextLabel context={payload.context} isSmall />
      </>
    ),
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
